import React from 'react'
import { styled } from 'linaria/react'
import ProductListCard from '../../Core/Cards/ProductListCard'
import { theme } from '../../Theme'
import { useIntl } from '@jetshop/intl'
import { Below } from '@jetshop/ui/Breakpoints'

const ProductContainer = styled.div`
   display: flex;
   overflow-x: auto;

   // ${theme.below.lg} {
   //    margin: 1.5rem 0 !important;
   // }

   & {
      padding: 1rem;
      margin: -1rem;
   }

   .heart-animation {
      display: none;
   }

   .product-card-cta {
      font-size: 12px;
   }

   .product-card-sku {
      font-size: 10px;
   }

   .product-card {
      max-width: 250px;
      min-width: 200px;
      scroll-snap-align: start;
      transition: all 0.2s;
   }
`

const StyledTitle = styled.h2`
   font-size: 1.5rem !important;
   ${theme.below.lg} {
      font-size: 1.5rem !important;
   }
`

const ProductAccessories = ({
   accessories,
   titleKey,
   title,
}) => {
   const t = useIntl()

   if (!accessories?.length) {
      return <></>
   }

   return (
      <div className="my-32">
         <Below breakpoint="lg">
            <hr className="my-32"></hr>
         </Below>
         <StyledTitle className="mb-16 product-sidebar-title">
            {t(titleKey, { title })}
         </StyledTitle>
         <ProductContainer>
            <div className="d-flex gap-3 mb-2">
               {accessories?.map((product, i) => {
                  return (
                     <ProductListCard
                        product={product}
                        key={i}
                     ></ProductListCard>
                  )
               })}
            </div>
         </ProductContainer>
      </div>
   )
}

export default ProductAccessories